module.exports = __webpack_public_path__ + "../../../static/img/bs_ic_05_dis.0b6782bb.png";